const queryKeys = {
  all: () => ['onesurance'] as const,

  recommendation: (emailId: string) =>
    [...queryKeys.all(), 'recommendations', emailId] as const,
};

export default queryKeys;
